<template>
  <div id="member-activity-list">
    <v-overlay :value="OverlayLoadingFlag">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <v-card-title class="text-h5">
        <h2>{{ PageTitle }}</h2>
        <v-spacer></v-spacer>
        <v-row wrap>
          <v-col cols="12" md="12" lg="12" class="text-center">
            <router-link to="/my-activity/list">
              <v-btn
                color="#8950FC"
                elevation="30"
                rounded
                medium
                class="font-size-h6 mr-3 px-3 py-3 white--text"
              >
                My Activity List
              </v-btn>
            </router-link>
            <v-btn
              medium
              @click.prevent="refreshPageData"
              color="#a4c639"
              elevation="30"
              rounded
              class="font-size-h6 mr-3 px-3 py-3 white--text"
            >
              Refresh
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-subtitle class="text-h5">
        <!-- <h4>{{ PageDescription }}</h4> -->
      </v-card-subtitle>
      <v-card-text>
        <v-form ref="form1" v-model="valid1" lazy-validation>
          <h5 class="text-center text-dark mt-4">Event Details</h5>
          <v-row wrap class="mt-4">
            <v-col cols="12" sm="12" md="12" lg="4">
              <label>
                <h6><span class="text-danger">* </span>Date</h6>
              </label>
              <v-dialog ref="dialog" v-model="DatePicker" width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="ActivityDate"
                    label="Select Date Here"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="ActivityDate"
                  @input="DatePicker = false"
                ></v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="4">
              <label>
                <h6><span class="text-danger">* </span>Organization Type</h6>
              </label>
              <v-autocomplete
                :reduce="(option) => option.value"
                :loading="OrganizationTypeOptionsLoading"
                :items="OrganizationTypeOptions"
                :rules="OrganizationTypeRules"
                v-model="OrganizationType"
                required
                outlined
                dense
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="4">
              <label>
                <h6><span class="text-danger">* </span>Guest/Faculty Type</h6>
              </label>
              <v-autocomplete
                :reduce="(option) => option.value"
                :loading="FacultyTypeOptionsLoading"
                :items="FacultyTypeOptions"
                :rules="FacultyTypeRules"
                v-model="FacultyType"
                required
                outlined
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="4">
              <label>
                <h6><span class="text-danger">* </span>Zone</h6>
              </label>
              <v-autocomplete
                :reduce="(option) => option.value"
                :loading="ZoneCodeOptionsLoading"
                :items="ZoneCodeOptions"
                :rules="ZoneCodeRules"
                v-model="ZoneCode"
                required
                outlined
                dense
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="4">
              <label>
                <h6><span class="text-danger">* </span>LO</h6>
              </label>
              <v-autocomplete
                :reduce="(option) => option.value"
                :loading="LomCodeOptionsLoading"
                :items="LomCodeOptions"
                :rules="LomCodeRules"
                v-model="LomCode"
                required
                outlined
                dense
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-divider />
          <h5 class="text-center text-dark mt-4 mb-4">
            Event Invitation Image (optional)
          </h5>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="5">
              <label>
                <h6 class="text-dark">Upload Invitation Image here</h6>
              </label>
              <v-file-input
                v-model="InvitationImage.UploadedImage"
                :rules="InvitationImageRules"
                :clearable="false"
                accept="image/png, image/jpeg, image/jpg"
                prepend-icon="mdi-image"
                append-outer-icon="mdi-delete"
                truncate-length="25"
                show-size
                @change="previewInvitationImage"
              >
                <template v-slot:append-outer>
                  <v-icon color="red" @click="deleteInvitationImage()">
                    mdi-delete
                  </v-icon>
                </template>
              </v-file-input>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="7"
              v-if="InvitationImageUrl != ''"
            >
              <h6>Invitation Image Preview</h6>
              <img :src="InvitationImageUrl" height="100px" width="100px" />
            </v-col>
          </v-row>
          <v-divider />
          <h5 class="text-center text-dark mt-4 mb-4">
            Event Image (optional)
            <v-btn
              color="blue"
              class="white--text"
              rounded
              v-if="EventImageMax > EventImageArray.length"
              @click="addNewRow()"
            >
              <!-- <v-icon>mdi-plus-circle</v-icon> -->
              Add Event Images
            </v-btn>
          </h5>

          <v-row>
            <v-col cols="12" sm="12" md="12" lg="4">
              <v-alert
                border="left"
                color="info"
                icon="mdi-alert-circle-outline"
                dense
                dark
              >
                <h6>You can add upto {{ EventImageMax }} event images.</h6>
              </v-alert>
            </v-col>
          </v-row>

          <v-row v-if="EventImageArray.length > 0">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="4"
              v-for="(row, index) in EventImageArray"
              :key="index"
            >
              <v-card>
                <v-card-title class="text-right">
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="10">
                      <h6 class="text-dark text-center">
                        Event Image - {{ index + 1 }}
                      </h6>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="2">
                      <v-icon color="red" @click="deleteRow(index)">
                        mdi-delete-circle-outline
                      </v-icon>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <v-file-input
                    v-model="row.EventImage"
                    :rules="row.EventImageRules"
                    truncate-length="25"
                    accept="image/png, image/jpeg"
                    label="Upload Event Photo Here"
                    prepend-icon="mdi-image"
                    append-outer-icon="mdi-delete"
                    :clearable="false"
                    show-size
                    @change="previewEventImage(index)"
                  >
                    <template v-slot:append-outer>
                      <v-icon color="red" @click="deleteImage(index)">
                        mdi-delete
                      </v-icon>
                    </template>
                  </v-file-input>
                  <h6 align="center" v-if="row.EventImageUrl != ''">
                    <img
                      style="padding: 5px"
                      width="100"
                      height="100"
                      :src="row.EventImageUrl"
                    />
                  </h6>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row class="mb-4">
            <v-col cols="12" sm="12" lg="12" md="12" class="text-center mt-6">
              <v-btn
                @click="confirmAlert()"
                :disabled="!valid1"
                class="font-size-h6 white--text"
                color="green"
                :loading="submitFlag"
                rounded
              >
                Submit
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  data() {
    return {
      search: "",
      uploadPercentage: 0,
      LoadingFlag: false,
      OverlayLoadingFlag: false,
      valid1: true,
      submitFlag: false,

      DatePicker: false,
      ActivityDate: "",

      OrganizationTypeOptionsLoading: false,
      OrganizationTypeOptions: [],
      OrganizationTypeRules: [(v) => !!v || "Organization Type is required"],
      OrganizationType: "",

      FacultyTypeOptionsLoading: false,
      FacultyTypeOptions: [],
      FacultyTypeRules: [(v) => !!v || "Guest / Faculty Type is required"],
      FacultyType: "",

      ZoneCodeOptionsLoading: false,
      ZoneCodeOptions: [],
      ZoneCodeRules: [(v) => !!v || "Zone is required"],
      ZoneCode: "",

      LomCodeOptionsLoading: false,
      LomCodeOptions: [],
      LomCodeRules: [(v) => !!v || "LO is required"],
      LomCode: "",

      InvitationImage: {},
      InvitationImageUrl: "",
      InvitationImageRules: [
        (v) =>
          !v ||
          v.size < 2000000 ||
          "Invitation image size should be less than 2 MB!",
      ],

      EventImageMax: 4,
      EventImageArray: [],

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      FloatingButtonOptions: {},
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;
        this.FloatingButtonOptions = tr.FloatingButtonOptions;
        this.pageData();
      }
    },
    OrganizationTypeOptions: function () {
      console.log("watch OrganizationTypeOptions called");
      this.OrganizationTypeOptionsLoading = false;
    },
    FacultyTypeOptions: function () {
      console.log("watch FacultyTypeOptions called");
      this.FacultyTypeOptionsLoading = false;
    },
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions called");
      this.ZoneCodeOptionsLoading = false;
    },
    LomCodeOptions: function () {
      console.log("watch LomCodeOptions called");
      this.LomCodeOptionsLoading = false;
    },
    ZoneCode: function () {
      console.log("watch ZoneCode called");
      this.getLomCodeOptions();
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "member_activity",
        Action: "create",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      this.resetAll();
      this.getOrganizationTypeOptions();
      this.getFacultyTypeOptions();
      this.getZoneCodeOptions();
    },
    resetAll() {
      console.log("resetAll called");
      this.OrganizationType = "";
      this.FacultyType = "";
      this.ZoneCode = "";
      this.LomCode = "";
      this.InvitationImage = {};
    },
    previewInvitationImage() {
      console.log("previewInvitationImage called");
      console.log("InvitationImage = ", this.InvitationImage);
      this.InvitationImageUrl = "";
      this.InvitationImageUrl = URL.createObjectURL(
        this.InvitationImage.UploadedImage
      );
    },
    deleteInvitationImage() {
      console.log("deleteInvitationImage called");
      this.InvitationImage = {};
      this.InvitationImageUrl = "";
    },
    previewEventImage(id) {
      console.log("previewEventImage called");
      console.log({ id });
      this.EventImageArray.forEach((row, index) => {
        console.log({ index });
        console.log({ row });
        if (id == index) {
          var url = URL.createObjectURL(row["EventImage"]);
          console.log({ url });
          row["EventImageUrl"] = url;
        }
      });
    },
    deleteImage(id) {
      console.log("deleteImage called");
      console.log({ id });
      this.EventImageArray.forEach((row, index) => {
        console.log({ index });
        console.log({ row });
        if (id == index) {
          row["EventImage"] = {};
          row["EventImageUrl"] = "";
        }
      });
    },
    addNewRow() {
      console.log("addNewRow called");
      this.EventImageArray.push({
        EventImage: {},
        EventImageUrl: "",
        EventImageRules: [
          (v) =>
            !v ||
            v.size < 2000000 ||
            "Event image size should be less than 2 MB!",
        ],
      });
    },
    deleteRow(id) {
      console.log("deleteRow called");
      console.log({ id });
      this.EventImageArray.splice(id, 1);
    },
    getOrganizationTypeOptions() {
      console.log("getOrganizationTypeOptions called");

      this.OrganizationTypeOptionsLoading = true;
      var selectbox1_source = "OrganizationType";
      var selectbox1_destination = "OrganizationTypeOptions";
      var selectbox1_url = "api/organization-type/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getFacultyTypeOptions() {
      console.log("getFacultyTypeOptions called");

      this.FacultyTypeOptionsLoading = true;
      var selectbox1_source = "FacultyType";
      var selectbox1_destination = "FacultyTypeOptions";
      var selectbox1_url = "api/sub-category/options";
      var selectbox1_conditions_array = {
        UserInterface: 3,
        CategoryMainName: "event_faculty_type",
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");

      this.ZoneCodeOptionsLoading = true;
      var selectbox1_source = "ZoneCode";
      var selectbox1_destination = "ZoneCodeOptions";
      var selectbox1_url = "api/year-wise-lom/zone-options";
      var selectbox1_conditions_array = {
        UserInterface: 4,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");

      var zone_code = this.ZoneCode;
      console.log({ zone_code });

      if (zone_code > 0) {
        this.LomCodeOptionsLoading = true;
        var selectbox1_source = "LomCode";
        var selectbox1_destination = "LomCodeOptions";
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          ZoneCode: zone_code,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    confirmAlert() {
      console.log("confirmAlert called");

      var validate1 = this.$refs.form1.validate();
      console.log({ validate1 });

      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields.";
        }
        this.sweetAlert("error", message, false);
      }
    },
    submitForm() {
      console.log("submitForm is called");

      this.OverlayLoadingFlag = true;

      var formData = {
        ActivityDate: this.ActivityDate,
        OrganizationType: this.OrganizationType,
        FacultyType: this.FacultyType,
        Zone: this.ZoneCode,
        LO: this.LomCode,
        EventImageCount: this.EventImageArray.length,
      };

      let upload = new FormData();
      upload.append("UserInterface", 1);
      upload.append("Form", JSON.stringify(formData));
      upload.append("InvitationImage", this.InvitationImage.UploadedImage);

      this.EventImageArray.forEach((row, index) => {
        console.log({ index });
        console.log({ row });

        var image_file = row["EventImage"];
        console.log({ image_file });

        upload.append("EventImage" + index, image_file);
      });

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;

      var add_url = server_url + "api/member-activity/store";
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.OverlayLoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          records = response.data.records;
          console.log({ output }, { flag }, { records });

          if (flag == 1) {
            thisIns.sweetAlert("success", output, true);
            thisIns.$router.push("/my-activity/list");
          } else {
            thisIns.sweetAlert("error", output, false);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.OverlayLoadingFlag = false;

          thisIns.sweetAlert("error", output, false);
        });
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss">
#member-activity-list {
  .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    font-size: 15px;
  }

  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 14px;
  }
}
</style>